export default __webpack_public_path__ + "static/portfolioMgmt-0ba78bcb7e8cafe9358c0e3db6057312.svg";